// import React from 'react';
// import Select from 'react-select';
// import { useTranslation } from 'react-i18next';
// import { type FormikProps } from 'formik';
// import Loading from '@components/Shared/Loader/Loading';
// import useGetOnhandInventoryItemsByInventoryId from '@hooks/INV/MasterItems/useGetOnhandInventoryItemsByInventoryId';

// interface LinesProps {
//   formik: FormikProps<any>;
// }

// const UpdateCostLines: React.FC<LinesProps> = ({ formik }) => {
//   //#region Handle InvLines
//   const { values, setFieldValue, errors } = formik;
//   const { i18n, t } = useTranslation();
//   const { InventoryItemsOptions, loading, error } = useGetOnhandInventoryItemsByInventoryId(values.inventoryId);

//   const handleLineChange = (index: number, field: string, value: any) => {
//     const updatedLines = [...values.materialTransactionsLineList];

//     if (field === 'transactionItemId') {
//       // const unitPrice = InventoryItemsOptions?.find((f) => f.value === value)?.purchasePrice || 0;
//       const transactionUom = InventoryItemsOptions?.find(f => f.itemId === value && f.isPrimaryUOM)?.uom;

//       updatedLines[index] = {
//         ...updatedLines[index],
//         [field]: value,
//         transactionUom,
//         unitPrice: Number(0),
//         total: Number(updatedLines[index].transactionQuantityIn) * Number(0)
//       };
//     } else {
//       updatedLines[index] = {
//         ...updatedLines[index],
//         [field]: value
//       };
//     }

//     formik.setFieldValue('materialTransactionsLineList', updatedLines);
//   };

//   const handleAddLine = () => {
//     const newLine: any = {
//       // lineNumber: Lines?.length + 1,
//       id: null, //
//       transactionItemId: null,
//       transactionUom: '',
//       unitPrice: 0,
//       transactionQuantityIn: 0,
//       transactionQuantityOut: 0,
//       lotId: null,
//       //________________________
//       inventoryId: '',
//       discount: 0,
//       codeCombinationId: '',
//       currencyCode: '',
//       currencyConversionRate: 0,
//       referenceIdMaster: '',
//       referenceIdLine: '',
//       transactionTypeId: '',
//       equivalent: 0,
//       expensesAmount: 0,
//       batchId: ''
//     };

//     const currentLines = formik.values.materialTransactionsLineList || []; // تأكد من أن القائمة موجودة كمصفوفة
//     formik.setFieldValue('materialTransactionsLineList', [...currentLines, newLine]);
//   };

//   const handleDeleteLine = (index: number) => {
//     const updatedLines = values.materialTransactionsLineList?.filter((_: any, i: number) => i !== index);
//     formik?.setFieldValue('materialTransactionsLineList', updatedLines);
//   };

//   const calculateTotalSum = () => {
//     const total = values.materialTransactionsLineList?.reduce((sum: any, line: { total: any }) => sum + line.total, 0);
//     const formattedTotal = new Intl.NumberFormat('en-US').format(total);
//     return formattedTotal;
//   };

//   //#endregion

//   return (
//     <>
//       <Loading loading={loading} error={error} Type='Dots'>
//         <div className='mb-3'>
//           <div className='row'>
//             <div className='col-3'>
//               <div className='mb-1 rounded-3 p-2 bg-inverse bg-opacity-10'>
//                 <div className='d-flex justify-content-around'>
//                   <div className='fw-bold'>{t('Total')} :</div>
//                   <div className='text-theme fs-5 fw-bold'>{calculateTotalSum()}</div>
//                 </div>
//               </div>
//             </div>

//             <div className='col-lg-6'></div>
//             <div className='col-lg-3 text-end '>
//               <div className='text-end mb-2'>
//                 <button type='button' className='btn btn-theme' onClick={handleAddLine}>
//                   {t('إضافة صنف')}
//                 </button>
//               </div>
//             </div>
//           </div>

//           <div className=''>
//             <div
//               className={`table-responsive rounded-2 text-center ${
//                 formik.errors.materialTransactionsLineList ? 'border-bottom border-2 border-danger' : ''
//               } `}
//             >
//               <table className='table table-borderless  table-hover mb-0 '>
//                 <thead className='bg-theme bg-opacity-30'>
//                   <tr>
//                     <th className='align-middle' style={{ width: '3%' }}>
//                       #
//                     </th>
//                     <th className='align-middle' style={{ width: '48%' }}>
//                       {t('اسم الصنف')}
//                     </th>
//                     <th className='align-middle' style={{ width: '15%' }}>
//                       {t('الوحدة')}
//                     </th>
//                     {/* <th className="align-middle" style={{ width: '15%' }}>
//                       {t('Lot Number')}
//                     </th> */}
//                     <th className='align-middle' style={{ width: '8%' }}>
//                       {t('الكمية')}
//                     </th>
//                     <th className='align-middle' style={{ width: '8%' }}>
//                       {t('السعر')}
//                     </th>

//                     <th className='align-middle text-end' style={{ width: '3%' }}></th>
//                   </tr>
//                 </thead>

//                 <tbody className='fw-bold'>
//                   {values.materialTransactionsLineList
//                     ?.slice()
//                     ?.reverse()
//                     ?.map((line: any, index: any) => {
//                       const Index = values.materialTransactionsLineList?.length - 1 - index;

//                       return (
//                         <tr key={index}>
//                           <td className='align-middle bg-theme bg-opacity-30 small'>
//                             {values.materialTransactionsLineList?.length - index}
//                           </td>
//                           <td className='align-middle small'>
//                             <Select
//                               classNamePrefix='react-select'
//                               className='w-100'
//                               isSearchable
//                               isClearable
//                               options={InventoryItemsOptions?.filter(
//                                 (item, index, self) => index === self?.findIndex(i => i.itemId === item.itemId)
//                               )}
//                               onChange={option =>
//                                 handleLineChange(Index, 'transactionItemId', option === null ? null : option.value)
//                               }
//                               value={
//                                 line.transactionItemId === null
//                                   ? null
//                                   : InventoryItemsOptions?.find(option => option.value === line.transactionItemId)
//                               }
//                               placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//                               menuPortalTarget={document.body}
//                               styles={{
//                                 menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
//                               }}
//                               formatOptionLabel={option => (
//                                 <div className='d-flex justify-content-between   '>
//                                   <div className=''>{option.label}</div>
//                                   <div className='text-theme fw-bold'>{option.barcode}</div>
//                                 </div>
//                               )}
//                             />
//                           </td>

//                           <td className='align-middle small'>
//                             <select
//                               className='form-select text-center'
//                               value={line.transactionUom || ''}
//                               onChange={e => handleLineChange(Index, 'transactionUom', e.target.value)}
//                             >
//                               {InventoryItemsOptions?.filter(f => f.itemId === line.transactionItemId)?.map(
//                                 (item, idx) => (
//                                   <option key={++idx} value={item.uom}>
//                                     {item.uomName}
//                                   </option>
//                                 )
//                               )}
//                             </select>
//                           </td>

//                           <td className='align-middle small'>
//                             <input
//                               type='text'
//                               autoComplete='off'
//                               className='form-control text-center px-0'
//                               value={line.transactionQuantityIn}
//                               onChange={e => handleLineChange(Index, 'transactionQuantityIn', Number(e.target.value))}
//                               onInput={e => {
//                                 const input = e.target as HTMLInputElement;
//                                 input.value = input.value?.replace(/[^0-9]/g, '');
//                               }}
//                             />
//                           </td>

//                           <td className='align-middle small'>
//                             <input
//                               type='text'
//                               autoComplete='off'
//                               className='form-control text-center px-0'
//                               value={line.unitPrice}
//                               onChange={e => handleLineChange(Index, 'unitPrice', Number(e.target.value))}
//                               onInput={e => {
//                                 const input = e.target as HTMLInputElement;
//                                 input.value = input.value.replace(/[^0-9]/g, '');
//                               }}
//                             />
//                           </td>

//                           <td className='align-middle small'>
//                             <button
//                               type='button'
//                               className='btn btn-outline-danger'
//                               onClick={() => handleDeleteLine(Index)}
//                             >
//                               <i className='fas fa-trash-alt'></i>
//                             </button>
//                           </td>
//                         </tr>
//                       );
//                     })}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>
//       </Loading>
//     </>
//   );
// };

// export default UpdateCostLines;

import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { type FormikProps } from 'formik';

// ✅ Picker
import { useItemUomPicker, ItemUomPickerModal } from '@pages/INV/lookups/useItemUomPicker';

// ✅ API (lookup)
import {
  lookupItemsWithUomRowsByItemIds,
  mergeIntoDetailsMap,
  makeDetailsKey
} from '@pages/INV/lookups/itemsWithUomLookup.logic';

interface LinesProps {
  formik: FormikProps<any>;
}

type ItemType = 'InventoryItem';
const DEFAULT_ITEM_TYPE: ItemType = 'InventoryItem';

// ✅ Pagination
const PAGE_SIZE = 20;

const n = (v: any) => {
  const x = Number(v);
  return Number.isFinite(x) ? x : 0;
};

const UpdateCostLines: React.FC<LinesProps> = ({ formik }) => {
  const { values } = formik;
  const { i18n, t } = useTranslation();

  const isPosted = values?.postedFlag === true;

  const canPickItem = !isPosted;
  const canChangeUom = !isPosted;
  const canAddLine = !isPosted;
  const canDeleteLine = !isPosted;
  const canEditQty = !isPosted;
  const canEditPrice = !isPosted;

  // ✅ Picker
  const { pickItemUom, modalProps } = useItemUomPicker();

  const allLines: any[] = values.materialTransactionsLineList || [];

  // =========================
  // ✅ Pagination: show only 20 lines initially (NO reverse)
  // =========================
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);

  useEffect(() => {
    setVisibleCount(PAGE_SIZE);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.inventoryId]);

  const visibleLines: any[] = useMemo(() => {
    return allLines.slice(0, visibleCount);
  }, [allLines, visibleCount]);

  const hasMoreLines = allLines.length > visibleCount;
  const remainingToShow = Math.max(0, Math.min(PAGE_SIZE, allLines.length - visibleCount));

  // =========================
  // ✅ detailsMap: itemId|uom -> row (contains names, barcode, uoms, etc.)
  // =========================
  const [detailsMap, setDetailsMap] = useState<Map<string, any>>(new Map());
  const detailsMapRef = useRef(detailsMap);
  useEffect(() => {
    detailsMapRef.current = detailsMap;
  }, [detailsMap]);

  // ✅ fast access by itemId (so item name doesn't stay as ID)
  const anyRowByItemId = useMemo(() => {
    const m = new Map<string, any>();
    for (const r of detailsMap.values()) {
      if (!r?.itemId) continue;
      const k = String(r.itemId);
      if (!m.has(k)) m.set(k, r);
    }
    return m;
  }, [detailsMap]);

  const anyRowByItemIdRef = useRef(anyRowByItemId);
  useEffect(() => {
    anyRowByItemIdRef.current = anyRowByItemId;
  }, [anyRowByItemId]);

  const [detailsLoading, setDetailsLoading] = useState(false);
  const detailsAbortRef = useRef<AbortController | null>(null);
  const detailsTimerRef = useRef<any>(null);
  const detailsReqSeqRef = useRef(0);

  // ✅ UOM preload per item
  const loadedUomsRef = useRef(new Set<string>());
  const uomsAbortRef = useRef<AbortController | null>(null);
  const [uomsLoading, setUomsLoading] = useState(false);

  // =========================
  // Helpers
  // =========================
  const lineHasDuplicateItemUom = (itemId: any, uom: any, excludeIndex: number) => {
    if (!itemId || !uom) return false;
    return (values.materialTransactionsLineList || []).some((l: any, i: number) => {
      if (i === excludeIndex) return false;
      return String(l?.transactionItemId || '') === String(itemId) && String(l?.transactionUom || '') === String(uom);
    });
  };

  const resetLine = (line: any) => ({
    ...line,
    transactionItemId: null,
    transactionUom: '',
    lotId: null,
    transactionQuantityIn: 0,
    transactionQuantityOut: 0,
    unitPrice: 0,
    total: 0
  });

  const getInfoExact = (line: any) => {
    if (!line?.transactionItemId || !line?.transactionUom) return null;
    return detailsMap.get(makeDetailsKey(line.transactionItemId, line.transactionUom)) || null;
  };

  const getInfoAnyByItemId = (itemId: any) => {
    if (!itemId) return null;
    return anyRowByItemIdRef.current.get(String(itemId)) || null;
  };

  const getInfoLoose = (line: any) => {
    const exact = getInfoExact(line);
    if (exact) return exact;
    return getInfoAnyByItemId(line?.transactionItemId);
  };

  const getItemNameForLine = (line: any) => {
    const info = getInfoLoose(line);
    const isEn = i18n.language === 'en';
    const name = (isEn ? info?.name || info?.name2 : info?.name2 || info?.name) || '';
    if (name) return name;

    return (
      (isEn
        ? line?.itemName || line?.transactionItemName || line?.itemName2 || line?.transactionItemName2
        : line?.itemName2 || line?.transactionItemName2 || line?.itemName || line?.transactionItemName) || ''
    );
  };

  const getUomNameForLine = (line: any) => {
    const info = getInfoLoose(line);
    const isEn = i18n.language === 'en';
    return (
      (isEn
        ? info?.unitOfMeasureName || info?.unitOfMeasureName2
        : info?.unitOfMeasureName2 || info?.unitOfMeasureName) || ''
    );
  };

  const getCodeOrBarcodeForLine = (line: any) => {
    const info = getInfoLoose(line);
    return info?.barcode || info?.itemCode || line?.itemCode || line?.barcode || '-';
  };

  // =========================
  // ✅ UOM options per itemId (from detailsMap only)
  // =========================
  const uomsByItemId = useMemo(() => {
    const map = new Map<string, any[]>();

    for (const r of detailsMap.values()) {
      if (!r?.itemId) continue;
      const list = map.get(String(r.itemId)) ?? [];
      list.push(r);
      map.set(String(r.itemId), list);
    }

    for (const [itemId, list] of map.entries()) {
      const uniq = new Map<string, any>();
      for (const r of list) uniq.set(String(r.unitOfMeasure), r);

      const arr = Array.from(uniq.values());
      // ✅ primary first if present
      arr.sort((a, b) => Number(!!b.isPrimaryUOM) - Number(!!a.isPrimaryUOM));
      map.set(itemId, arr);
    }

    return map;
  }, [detailsMap]);

  // =========================
  // ✅ fetch UOMs for item (light)
  // =========================
  const ensureItemUomsLoaded = async (itemId: string) => {
    if (!values.inventoryId || !itemId) return;

    const key = `${values.inventoryId}|${DEFAULT_ITEM_TYPE}|${itemId}`;
    if (loadedUomsRef.current.has(key)) return;
    loadedUomsRef.current.add(key);

    try {
      uomsAbortRef.current?.abort();
      uomsAbortRef.current = new AbortController();
      setUomsLoading(true);

      const params: any = { InventoryId: values.inventoryId, Scope: 1 };

      const rows = await lookupItemsWithUomRowsByItemIds({
        params,
        itemType: DEFAULT_ITEM_TYPE,
        itemIds: [itemId],
        pageSize: 3000,
        pageIndex: 1,
        chunkSize: 200,
        bodyExtra: {
          dynamicFields: [] // ✅ ما نحتاج onhand هنا
        },
        opts: {
          signal: uomsAbortRef.current?.signal,
          cache: true,
          dedupeInFlight: true
        }
      });

      if (!rows.length) return;
      setDetailsMap(prev => mergeIntoDetailsMap(prev, rows));
    } catch (e: any) {
      loadedUomsRef.current.delete(key);
      if (e?.name !== 'CanceledError') console.error(e);
    } finally {
      setUomsLoading(false);
    }
  };

  // =========================
  // ✅ preload details for VISIBLE lines only (debounce + abort)
  // =========================
  const visibleLinesKey = useMemo(() => {
    return visibleLines.map((l: any) => `${l?.transactionItemId || ''}:${l?.transactionUom || ''}`).join('|');
  }, [visibleLines]);

  useEffect(() => {
    if (detailsTimerRef.current) clearTimeout(detailsTimerRef.current);

    detailsAbortRef.current?.abort();
    detailsAbortRef.current = null;

    detailsTimerRef.current = setTimeout(async () => {
      if (!values.inventoryId) return;

      const lines = visibleLines || [];
      const valid = lines.filter((l: any) => l?.transactionItemId && l?.transactionUom);
      if (valid.length === 0) return;

      const mapNow = detailsMapRef.current;
      const missingItemIds = new Set<string>();

      for (const l of valid) {
        const k = makeDetailsKey(l.transactionItemId, l.transactionUom);
        if (!mapNow.has(k)) missingItemIds.add(String(l.transactionItemId));
      }

      if (missingItemIds.size === 0) return;

      const seq = ++detailsReqSeqRef.current;

      detailsAbortRef.current?.abort();
      detailsAbortRef.current = new AbortController();

      setDetailsLoading(true);

      try {
        const params: any = { InventoryId: values.inventoryId, Scope: 1 };
        const ids = Array.from(missingItemIds);

        const rows = await lookupItemsWithUomRowsByItemIds({
          params,
          itemType: DEFAULT_ITEM_TYPE,
          itemIds: ids,
          pageSize: 3000,
          pageIndex: 1,
          chunkSize: 200,
          bodyExtra: {
            dynamicFields: []
          },
          opts: {
            signal: detailsAbortRef.current?.signal,
            cache: true,
            dedupeInFlight: true
          }
        });

        setDetailsMap(prev => mergeIntoDetailsMap(prev, rows));
      } catch (e: any) {
        if (e?.name !== 'CanceledError') console.error(e);
      } finally {
        if (seq === detailsReqSeqRef.current) setDetailsLoading(false);
      }
    }, 150);

    return () => {
      if (detailsTimerRef.current) clearTimeout(detailsTimerRef.current);
      detailsAbortRef.current?.abort();
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.inventoryId, visibleLinesKey, visibleCount]);

  // ✅ clear caches when inventory changes
  useEffect(() => {
    setDetailsMap(new Map());
    loadedUomsRef.current.clear();
  }, [values.inventoryId]);

  // =========================
  // Picker
  // =========================
  const openPickerForLine = async (lineIndex: number) => {
    const lines = values.materialTransactionsLineList || [];
    const line = lines[lineIndex];
    if (!line) return;

    if (!values.inventoryId) {
      window?.alert?.(t('يجب اختيار المخزن أولاً.'));
      return;
    }
    if (!canPickItem) return;

    const params: any = { InventoryId: values.inventoryId, Scope: 1 };

    const picked = await pickItemUom({
      title: i18n.language === 'en' ? 'Pick Item & UOM' : 'اختيار الصنف',
      params,
      bodyDefaults: { itemType: DEFAULT_ITEM_TYPE },
      pageSize: 10,
      searchMode: 'manual',
      initialSearchField: 'barcodeEqual',
      isDisabledRow: (r: any) => lineHasDuplicateItemUom(r.itemId, r.unitOfMeasure, lineIndex),
      dynamicFields: []
    });

    if (!picked) return;

    const row: any = picked.row;
    if (!row?.itemId || !row?.unitOfMeasure) return;

    if (lineHasDuplicateItemUom(row.itemId, row.unitOfMeasure, lineIndex)) {
      window?.alert?.(t('لا يمكن تكرار نفس الصنف بنفس الوحدة.'));
      return;
    }

    setDetailsMap(prev => mergeIntoDetailsMap(prev, [row]));
    ensureItemUomsLoaded(String(row.itemId));

    const updated = [...lines];
    updated[lineIndex] = {
      ...resetLine(updated[lineIndex]),
      transactionItemId: row.itemId,
      transactionUom: row.unitOfMeasure
    };

    formik.setFieldValue('materialTransactionsLineList', updated);
  };

  // =========================
  // Line change
  // =========================
  const handleLineChange = (index: number, field: string, value: any) => {
    const updatedLines = [...(values.materialTransactionsLineList || [])];
    if (!updatedLines[index]) return;

    const currentLine = { ...updatedLines[index] };

    if (field === 'clearItem') {
      if (!canPickItem) return;
      updatedLines[index] = resetLine(currentLine);
      formik.setFieldValue('materialTransactionsLineList', updatedLines);
      return;
    }

    if (field === 'transactionUom') {
      if (!canChangeUom) return;

      const itemId = currentLine.transactionItemId;
      if (itemId && value && lineHasDuplicateItemUom(itemId, value, index)) {
        window?.alert?.(t('لا يمكن تكرار نفس الصنف بنفس الوحدة.'));
        return;
      }

      const next = { ...currentLine, transactionUom: value };
      if (itemId) ensureItemUomsLoaded(String(itemId));

      // total stays qty*price
      next.total = n(next.transactionQuantityIn) * n(next.unitPrice);

      updatedLines[index] = next;
      formik.setFieldValue('materialTransactionsLineList', updatedLines);
      return;
    }

    if (field === 'transactionQuantityIn') {
      if (!canEditQty) return;
      const next = { ...currentLine, transactionQuantityIn: n(value) };
      next.total = n(next.transactionQuantityIn) * n(next.unitPrice);
      updatedLines[index] = next;
      formik.setFieldValue('materialTransactionsLineList', updatedLines);
      return;
    }

    if (field === 'unitPrice') {
      if (!canEditPrice) return;
      const next = { ...currentLine, unitPrice: n(value) };
      next.total = n(next.transactionQuantityIn) * n(next.unitPrice);
      updatedLines[index] = next;
      formik.setFieldValue('materialTransactionsLineList', updatedLines);
      return;
    }

    updatedLines[index] = { ...currentLine, [field]: value };
    formik.setFieldValue('materialTransactionsLineList', updatedLines);
  };

  // =========================
  // Add / Delete
  // =========================
  const handleAddLine = () => {
    if (!canAddLine) return;

    const newLine: any = {
      id: null,
      transactionItemId: null,
      transactionUom: '',
      unitPrice: 0,
      transactionQuantityIn: 0,
      transactionQuantityOut: 0,
      lotId: null,

      inventoryId: values.inventoryId || '',
      discount: 0,
      codeCombinationId: '',
      currencyCode: '',
      currencyConversionRate: 0,
      referenceIdMaster: '',
      referenceIdLine: '',
      transactionTypeId: '',
      equivalent: 0,
      expensesAmount: 0,
      batchId: '',

      total: 0
    };

    const currentLines = formik.values.materialTransactionsLineList || [];
    formik.setFieldValue('materialTransactionsLineList', [...currentLines, newLine]);
  };

  const handleDeleteLine = (index: number) => {
    if (!canDeleteLine) return;
    const updatedLines = (values.materialTransactionsLineList || []).filter((_: any, i: number) => i !== index);
    formik.setFieldValue('materialTransactionsLineList', updatedLines);
  };

  // =========================
  // Totals
  // =========================
  const calculateTotalSum = () => {
    const total = (values.materialTransactionsLineList || []).reduce(
      (sum: number, line: any) => sum + n(line?.total),
      0
    );
    return new Intl.NumberFormat('en-US').format(total);
  };

  const showMore = () => {
    setVisibleCount(v => Math.min(v + PAGE_SIZE, allLines.length));
  };

  return (
    <>
      <ItemUomPickerModal {...modalProps} />

      <div className='mb-3'>
        {/* ✅ Header summary */}
        <div className='row   '>
          <div className='col-lg-6 d-flex align-items-center'>
            {(detailsLoading || uomsLoading) && (
              <div className='d-flex align-items-center'>
                <span className='spinner-border spinner-border-sm text-theme me-2'></span>
                <small className='text-muted'>
                  {detailsLoading ? t('جاري تحميل التفاصيل...') : t('جاري تحميل الوحدات...')}
                </small>
              </div>
            )}
          </div>

          <div className='col-lg-6 text-end'>
            {canAddLine && (
              <button
                type='button'
                className='btn btn-theme rounded-0'
                onClick={handleAddLine}
                disabled={!values.inventoryId}
              >
                {t('إضافة صنف')}
              </button>
            )}
          </div>
        </div>

        {/* ✅ Table */}
        <div
          className={`table-responsive rounded-2 text-center ${
            formik.errors.materialTransactionsLineList ? 'border-bottom border-2 border-danger' : ''
          }`}
          style={{ maxHeight: '350px', overflow: 'auto', position: 'relative' }}
        >
          <table className='table table-hover mb-0' style={{ minWidth: '1000px' }}>
            <thead
              className='bg-theme bg-opacity-30 shadow fw-bold'
              style={{ position: 'sticky', top: 0, zIndex: 101, backdropFilter: 'blur(30px)' }}
            >
              <tr>
                <th className='align-middle' style={{ width: '3%' }}>
                  #
                </th>
                <th className='align-middle' style={{ width: '48%' }}>
                  {t('اسم الصنف')}
                </th>
                <th className='align-middle' style={{ width: '15%' }}>
                  {t('الوحدة')}
                </th>
                <th className='align-middle' style={{ width: '8%' }}>
                  {t('الكمية')}
                </th>
                <th className='align-middle' style={{ width: '8%' }}>
                  {t('السعر')}
                </th>
                <th className='align-middle text-end' style={{ width: '3%' }}></th>
              </tr>
            </thead>

            <tbody className='fw-bold'>
              {visibleLines.length > 0 ? (
                visibleLines.map((line: any, idx: number) => {
                  const Index = idx; // ✅ NO reverse
                  const info = getInfoLoose(line);

                  const itemName = line.transactionItemId ? getItemNameForLine(line) : '';
                  const uomName = line.transactionItemId ? getUomNameForLine(line) : '';
                  const codeOrBarcode = line.transactionItemId ? getCodeOrBarcodeForLine(line) : '-';

                  const isDuplicate =
                    line.transactionItemId &&
                    line.transactionUom &&
                    (values.materialTransactionsLineList || []).some(
                      (l: any, i: number) =>
                        i !== Index &&
                        String(l?.transactionItemId || '') === String(line.transactionItemId) &&
                        String(l?.transactionUom || '') === String(line.transactionUom)
                    );

                  const uomOptions = line.transactionItemId
                    ? uomsByItemId.get(String(line.transactionItemId)) || []
                    : [];

                  return (
                    <tr key={line?.id ?? Index}>
                      <td className='align-middle bg-theme bg-opacity-30 small'>{Index + 1}</td>

                      {/* ✅ Item cell (picker button like IssueLines) */}
                      <td className='align-middle'>
                        <div className={`p-2 border ${isDuplicate ? 'border-danger' : 'border-theme'} bg-body`}>
                          <div className='d-flex align-items-start gap-2'>
                            <div className='flex-grow-1' style={{ minWidth: 0 }}>
                              {line.transactionItemId ? (
                                <>
                                  <span className='fw-bold text-truncate d-block'>
                                    {itemName ? (
                                      itemName
                                    ) : detailsLoading ? (
                                      <span className='text-muted'>
                                        <span className='spinner-border spinner-border-sm me-2'></span>
                                        {i18n.language === 'en' ? 'Loading...' : 'جاري التحميل...'}
                                      </span>
                                    ) : (
                                      `ID: ${line.transactionItemId}`
                                    )}
                                  </span>

                                  <small className='text-muted d-block'>
                                    {t('Barcode')}:{' '}
                                    <span className='fw-bold'>{String(codeOrBarcode).slice(0, 40)}</span>
                                    <span className='mx-2'>•</span>
                                    {t('Unit')}: <span className='fw-bold text-theme'>{uomName || '-'}</span>
                                  </small>

                                  {isDuplicate && (
                                    <small className='text-danger d-block mt-1'>
                                      <i className='fas fa-exclamation-triangle me-1'></i>
                                      {t('هذا الصنف مكرر مع نفس الوحدة')}
                                    </small>
                                  )}
                                </>
                              ) : (
                                <span className='text-muted'>{t('Choose')}</span>
                              )}
                            </div>

                            <div className='d-flex gap-1'>
                              <button
                                disabled={!canPickItem || !values.inventoryId}
                                type='button'
                                className='btn btn-sm btn-theme rounded-0'
                                onClick={() => openPickerForLine(Index)}
                                title={!values.inventoryId ? t('يجب اختيار المخزن أولاً.') : t('اختيار صنف ووحدة')}
                              >
                                <i className='fas fa-search me-1'></i>
                                {line.transactionItemId ? t('تغيير') : t('اختيار')}
                              </button>

                              {line.transactionItemId && (
                                <button
                                  disabled={!canPickItem}
                                  type='button'
                                  className='btn btn-sm btn-outline-danger rounded-0'
                                  onClick={() => handleLineChange(Index, 'clearItem', true)}
                                  title={t('مسح الصنف')}
                                >
                                  <i className='fas fa-times'></i>
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </td>

                      {/* ✅ UOM dropdown */}
                      <td className='align-middle small'>
                        <select
                          disabled={!canChangeUom || !line.transactionItemId}
                          className={`form-select form-select-sm text-center bg-body ${
                            isDuplicate ? 'border-danger' : 'border-theme'
                          }`}
                          value={line.transactionUom || ''}
                          onFocus={() => {
                            if (line.transactionItemId) ensureItemUomsLoaded(String(line.transactionItemId));
                          }}
                          onChange={e => handleLineChange(Index, 'transactionUom', e.target.value)}
                        >
                          <option value=''>{t('Choose')}</option>

                          {line.transactionUom && uomOptions.length === 0 && (
                            <option value={line.transactionUom}>{uomName || line.transactionUom}</option>
                          )}

                          {uomOptions.map((u: any) => {
                            const uomVal = u.unitOfMeasure;
                            const label =
                              (i18n.language === 'en'
                                ? u.unitOfMeasureName || u.unitOfMeasureName2
                                : u.unitOfMeasureName2 || u.unitOfMeasureName) || `ID: ${uomVal}`;

                            return (
                              <option key={uomVal} value={uomVal}>
                                {label}
                              </option>
                            );
                          })}

                          {uomsLoading && line.transactionItemId ? (
                            <option value={line.transactionUom || ''} disabled>
                              {i18n.language === 'en' ? 'Loading...' : '...جاري التحميل'}
                            </option>
                          ) : null}
                        </select>
                      </td>

                      {/* ✅ Qty */}
                      <td className='align-middle small'>
                        <input
                          type='text'
                          autoComplete='off'
                          className='form-control form-control-sm text-center px-0 border-theme bg-body'
                          value={line.transactionQuantityIn}
                          disabled={!canEditQty}
                          onChange={e => handleLineChange(Index, 'transactionQuantityIn', Number(e.target.value))}
                          onInput={e => {
                            const input = e.target as HTMLInputElement;
                            input.value = input.value?.replace(/[^0-9]/g, '');
                          }}
                        />
                      </td>

                      {/* ✅ Price */}
                      <td className='align-middle small'>
                        <input
                          type='text'
                          autoComplete='off'
                          className='form-control form-control-sm text-center px-0 border-theme bg-body'
                          value={line.unitPrice}
                          disabled={!canEditPrice}
                          onChange={e => handleLineChange(Index, 'unitPrice', Number(e.target.value))}
                          onInput={e => {
                            const input = e.target as HTMLInputElement;
                            input.value = input.value.replace(/[^0-9]/g, '');
                          }}
                        />
                      </td>

                      {/* ✅ Delete */}
                      <td className='align-middle small'>
                        <button
                          type='button'
                          className='btn btn-outline-danger'
                          disabled={!canDeleteLine}
                          onClick={() => handleDeleteLine(Index)}
                        >
                          <i className='fas fa-trash-alt'></i>
                        </button>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={6} className='text-center py-4 text-muted'>
                    <i className='fa fa-inbox fa-2x mb-2'></i>
                    <br />
                    {t('لا توجد أصناف مضافة')}
                    <br />
                    {canAddLine && (
                      <button
                        type='button'
                        className='btn btn-theme mt-3'
                        onClick={handleAddLine}
                        disabled={!values.inventoryId}
                      >
                        <i className='fas fa-plus me-2'></i>
                        {t('إضافة اول صنف')}
                      </button>
                    )}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* ✅ Show more */}
        {hasMoreLines && remainingToShow > 0 && (
          <div className='p-2 text-center'>
            <button type='button' className='btn btn-outline-secondary btn-sm' onClick={showMore}>
              <i className='fas fa-chevron-down me-2'></i>
              {i18n.language === 'en' ? `Show more (${remainingToShow})` : `عرض المزيد (${remainingToShow})`}
            </button>

            <div className='text-muted small mt-1'>
              {i18n.language === 'en'
                ? `Showing ${Math.min(visibleCount, allLines.length)} of ${allLines.length}`
                : `المعروض ${Math.min(visibleCount, allLines.length)} من ${allLines.length}`}
            </div>
          </div>
        )}

        {formik.errors.materialTransactionsLineList?.length ? <div className='text-danger p-2'> * مطلوب </div> : null}

        {/* ✅ Posted hint */}
        {isPosted && (
          <div className='mt-2 text-theme fw-bold'>
            <i className='fas fa-info-circle me-2'></i>
            {i18n.language === 'en' ? 'Read only (Posted)' : 'قراءة فقط (مُرحّل)'}
          </div>
        )}
      </div>
    </>
  );
};

export default UpdateCostLines;
